/* eslint-disable no-param-reassign */

/**
 * Translate content from second view in modal
 *
 * @param {object} parentNode modal wrapper
 */
function checkIfExistAndTranslate(parentNode) {
  const interval = setInterval(() => {
    if (parentNode.querySelector('.swym-success-msg')) {
      parentNode.querySelector('.swym-success-msg').textContent = 'Awesome, we\'ll keep you informed with the latest updates.';
      parentNode.querySelector('.swym-privacy-info').textContent = 'We will send you an email once the product becomes available. Your email address will not be shared with anyone else.';
      clearInterval(interval);
    }
  }, 100);
}

/**
 * Translate content from first view in modal
 *
 * @param {object} parentNode modal wrapper
 */
function translate(parentNode) {
  parentNode.querySelector('.swym-title h2').textContent = 'Remind me when available';
  parentNode.querySelector('.swym-remind-description.swym-sbisa-v2').textContent = 'Get notified via email when this product is back in stock';
  parentNode.querySelector('.swym-input').placeholder = 'Enter your email address';
  parentNode.querySelector('#swym-remind-email-auth-button').textContent = 'Email Me';
  parentNode.querySelector('.swym-privacy-info').textContent = 'We will send you an email once the product becomes available. Your email address will not be shared with anyone else.';
  checkIfExistAndTranslate(parentNode);
}

/**
 *
 *
 * @param {object} targetNode modal wrapper
 */
function addMutationObserver(targetNode) {
  const config = { attributes: false, childList: true, subtree: true };
  const callback = (mutationList, observer) => {
    // eslint-disable-next-line
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        if (targetNode.querySelector('.swym-modal')) {
          translate(targetNode);
        }
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}

/**
 * Wait for app to add DOM nodes
 *
 */
function init() {
  const buttonInterval = setInterval(() => {
    const targetNode = document.querySelector('.swym-watchlist-cta');
    if (targetNode) {
      targetNode.textContent = 'Notify about availability';
      clearInterval(buttonInterval);
    }
  }, 100);

  const modalInterval = setInterval(() => {
    const targetNode = document.querySelector('.swym-modals-container');
    if (targetNode) {
      addMutationObserver(targetNode);
      clearInterval(modalInterval);
    }
  }, 100);
}

/**
 * Translate only on english
 *
 */
function run() {
  if (window.location.pathname.startsWith('/en/')) init();
}

run();
